class cssHeights {
  constructor(config = {}) {
    this.clientHeight = document.documentElement.clientHeight;
    this.header = document.querySelector('.wordpress-wrapper__inner--top');
    this.footer = document.querySelector('.wordpress-wrapper__inner--bottom');

    this.setCssHeights();
  }

  setCssHeights() {
    this.headerHeight = this.header.offsetHeight;
    this.footerHeight = this.footer.offsetHeight;
    this.minContentHeight = this.clientHeight - this.headerHeight - this.footerHeight - 182;
    this.navigationHeight = this.clientHeight - this.headerHeight;
    document.documentElement.style.cssText = `--min-content-height: ${this.minContentHeight}px; ` + `--navigation-height: ${this.navigationHeight}px`;
  }
}

export default cssHeights;
